export default __webpack_public_path__ + "static/media/sample.0fabfe67.webp";